import React from 'react'
import { Link } from 'react-router-dom'
import { 
  Action, 
  any, 
  async, 
  AsyncState, 
  IOWidget, 
  loadingAsyncState, 
  mk_widget, 
  stateful 
} from 'widgets-for-react'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { TemplateState } from '../../../../cms/page/types.gen'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { 
  getVacancies, 
  VacancyResponse 
} from '../../../../wordpress/wordpress_vacancy_api'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { loaderSVG } from '../../../utils/loader'
import { CustomBlockData } from '../types.mod'

export type BSLLatestVacanciesBlockProps = {
  key?: string
}

type BSLLatestVacanciesBlockState = {
  vacancies: AsyncState<VacancyResponse[]>
}

export type BSLLatestVacanciesBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  title_classname: string
  list_classname: string
  item_classname: string
  item_link_classname: string
  item_label_classname: string
  item_title_classname: string
  item_title_text_classname: string
  item_text_classname: string
  clickable_primary_classname: string
}>

export function BSLLatestVacanciesBlock<customBlockData, extra_images>(
  props: BSLLatestVacanciesBlockProps,
  options?: { style?: BSLLatestVacanciesBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  const numberOfVacancies = 4

  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    stateful<BSLLatestVacanciesBlockState>()(s0 =>
      any<Action<BSLLatestVacanciesBlockState>>()([
        async<VacancyResponse[]>()(s0.vacancies).map(a => s1 => ({
          ...s1,
          vacancies: a(s1.vacancies)
        })),
        mk_widget({
          run: setState => {
            if (s0.vacancies.kind == "loaded" && s0.vacancies.value.length <= 0) {
              return <></>
            }

            return (
              <>
                <section
                  className={getClassName(options, 'block_classname', 'block')}
                  key={options && options.key ? options.key : ''}
                >
                  <div className={getClassName(options, 'inner_classname', 'block__inner')}>
                    <h2 className={getClassName(options, 'title_classname', '')}>Vacatures</h2>
                    <div className={getClassName(options, 'list_classname', '')}>
                      {s0.vacancies.kind === 'loaded' ? (
                        <>
                          {s0.vacancies.value.slice(0, numberOfVacancies).map(vacancy => (
                            <div className={getClassName(options, 'item_classname', '')} key={vacancy.id}>
                              <Link
                                to={`/werken-bij/vacatures/${vacancy.slug}`}
                                className={getClassName(options, 'item_link_classname', '')}
                              >
                                <span className={getClassName(options, 'item_label_classname', '')}>Vacature</span>
                                <h2 className={getClassName(options, 'item_title_classname', '')}>
                                  <span className={getClassName(options, 'item_title_text_classname', '')}>
                                    {vacancy.title.rendered}
                                  </span>
                                </h2>
                                { 
                                  vacancy.acf.hero_intro &&
                                    <p className={getClassName(options, 'item_text_classname', '')}>
                                     <p dangerouslySetInnerHTML={{ __html: vacancy.acf.hero_intro }} />
                                    </p>
                                }
                              </Link>
                            </div>
                          ))}
                        </>
                      ) : (
                        <>
                          {Array(numberOfVacancies)
                            .fill(null)
                            .map((_, index) => (
                              <div className={getClassName(options, 'item_classname', '')} key={index}>
                                <div className={getClassName(options, 'item_link_classname', '')}>
                                  <span className={getClassName(options, 'item_label_classname', '')}>Vacature</span>
                                  <div className="svg-loader svg-loader--nobg" style={{ minHeight: 70 }}>
                                    {
                                      loaderSVG()
                                    }
                                  </div>
                                </div>
                              </div>
                            ))}
                        </>
                      )}
                    </div>
                    <a href="/werken-bij/vacatures" className={getClassName(options, 'clickable_primary_classname', '')}>
                      Bekijk alle
                    </a>
                  </div>
                </section>
              </>
            )
          }
        })
      ]).map(a => a(s0))
    )({
      vacancies: loadingAsyncState(() => getVacancies())
    }).map(a => s => s)
}
